export const LOCATIONS = [
    {
        slug: "boise-idaho",
        city: "Boise",
        county: "Ada County",
        blurb: "From the North End to Harris Ranch and out to the Bench, Boise yards fight hot, dry summers and cold snaps that wreck natural grass. Our PFAS-free turf stays green through all of it — no watering restrictions, no brown spots.",
        detail: "We install across every Boise neighborhood, from foothills estates to downtown townhome courtyards, with turf systems built for high desert sun and freeze-thaw winters.",
    },
    {
        slug: "meridian-idaho",
        city: "Meridian",
        county: "Ada County",
        blurb: "Meridian is one of the fastest-growing cities in America, and most new subdivisions start with a dust lot and a busy family. We turn those bare yards into soft, kid-and-dog-ready lawns in days, not seasons.",
        detail: "From Paramount to Bridgetower and south Meridian's newest communities, we design low-maintenance yards that look established the day we leave.",
    },
    {
        slug: "nampa-idaho",
        city: "Nampa",
        county: "Canyon County",
        blurb: "Nampa's bigger lots mean bigger water bills — and bigger weekends lost to mowing. Artificial turf flips that equation: a flawless lawn that never needs a sprinkler or a Saturday.",
        detail: "We serve all of Nampa, from older established neighborhoods near Lake Lowell to new builds along the southside corridor.",
    },
    {
        slug: "eagle-idaho",
        city: "Eagle",
        county: "Ada County",
        blurb: "Eagle is where we build our showpieces — estate lawns, custom putting greens, and poolside turf that look like a private club. If you want the best yard on the street, this is our specialty.",
        detail: "We regularly install along the Boise River corridor, Eagle Island, and the foothills communities, with discreet, detail-obsessed crews.",
    },
    {
        slug: "caldwell-idaho",
        city: "Caldwell",
        county: "Canyon County",
        blurb: "Caldwell gets some of the hottest, driest stretches in the Valley — brutal conditions for natural grass. Our turf is engineered to take full Idaho sun without fading, matting, or burning.",
        detail: "From downtown Caldwell to the acreages toward Lake Lowell, we build water-wise yards that cut irrigation costs to zero.",
    },
    {
        slug: "kuna-idaho",
        city: "Kuna",
        county: "Ada County",
        blurb: "Kuna's new neighborhoods are full of fresh dirt waiting to become something better. We shape, grade, and install complete turf yards — often before the moving boxes are even unpacked.",
        detail: "We work across Kuna's growing communities with fast scheduling and builder-friendly coordination for new construction.",
    },
    {
        slug: "star-idaho",
        city: "Star",
        county: "Ada County",
        blurb: "Star's larger properties and river-adjacent acreages are perfect for expansive turf lawns and backyard putting greens. More yard shouldn't mean more chores.",
        detail: "From Star's established river properties to its newest developments, we design installs scaled to bigger lots and bigger views.",
    },
];

export const getLocation = (slug) => LOCATIONS.find((l) => l.slug === slug);
